import Sidebar from "../components/sidebar";
import JointViewer from "../components/jointviewer";
import { useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import JointFile from "../models/joint-file";
import Joint from "../models/joint";
import MachineSettings from "../models/machine-settings";

export default function Downloads() {
    const { sample } = useParams<{ sample: string }>();
    const loadingSample = useRef<string>();

    const [file, setFile] = useState<JointFile | null>(null);
    const [selected, setSelected] = useState<Joint | null>(null);
    const [machineSettings] = useState(new MachineSettings());

    useEffect(() => {
        if (sample) {
            // Debounce
            if (sample === loadingSample.current) return;

            loadingSample.current = sample;
            fetchSample(sample);
        }

        async function fetchSample(path: string) {
            setFile(await JointFile.fetchSample(path));
        }
    }, [sample, file]);

    useEffect(() => {
        setSelected(file?.joints.find(j => j.enabled) || null);
    }, [file]);

    return (
        <main className="viewer-screen">
            <Sidebar
                file={file}
                onSetFile={setFile}
                selected={selected}
                onSelect={setSelected}
                machineSettings={machineSettings}
            />
            <JointViewer
                joint={selected}
                machineSettings={machineSettings}
            />
        </main>
    )
}
